import React from 'react';
import { componentService } from 'js/services/component.service';

export const PaymentHistory = React.lazy(() => import(/* webpackChunkName: "payment-history" */ './PaymentHistory'));

componentService.registerPageComponents({ paymenthistory: PaymentHistory });
